import { ENGT_CHAT } from 'js/bot.model';
import { chatSettingsHeader } from './chatSettingsHeader.model';
import { ChatSettingsHeaderTemplate } from './chatSettingsHeader.template';

export class ChatSettingsHeader {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initEvents();
	}

	initData(props) {
		this.data = {
			...chatSettingsHeader,
			title: ENGT_CHAT.get('GENERIC_STRINGS')?.['CHAT_SETTINGS'] || 'Chat Settings',
		};
		this.setter(props);
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.className = 'engt-chat-setings-header';
		wrapper.innerHTML = ChatSettingsHeaderTemplate(this.data);

		this.html = wrapper;
	}

	initEvents() {
		this.html.querySelector('.engt-chat-settings-back').addEventListener('click', () => {
			ENGT_CHAT.get('backToChatSettings')();
		});
		this.html.querySelector('.engt-chat-settings-close').addEventListener('click', () => {
			ENGT_CHAT.get('hideChatSettingsScreen')();
		});
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
